/* eslint-disable no-unused-vars */
 const list=[
    "免费课程",
    "实战课程",
    "就业班",
    "专栏",
    "猿问",
    "手记"
];
//侧边栏
const sidebar=[
    "前沿 / 区块链 / 人工智能",
    "前端 / 小程序 / JS",
    "后端 / JAVA / Python",
    "移动 / Android / iOS",
    "云计算 / 大数据 / 容器",
    "运维 / 测试 / 数据库",
    "UI设计 / 3D动画 / 游戏"
]
const innerBox=[
{
    title:"前沿技术",
    content:["微服务","区块链","以太坊","机器学习","深度学习","计算机视觉","自然语言处理","数据分析&挖掘"]
}
]
const innerBox2=[
    {
        title:"前端开发",
        content:["HTML/CSS","JavaSciprt","Vue.js","React.Js","Angular","Node.js","jQuery","Bootstrap","Sass/Less","WebApp","小程序","前端工具","CSS","Html5","CSS3"]
    }
]
const innerBox3=[
    {
        title:"后端开发",
        content:["Java","SpringBoot","Spring Cloud","Python","爬虫","Django","Tornado","Go","PHP","C","C++","C#","Ruby"]
    }
]
const innerBox4=[
    {
        title:"移动开发",
        content:["Android","iOS","React native","WEEX"]
    }
]
const innerBox5=[
    {
        title:"计算机基础",
        content:["计算机网络","算法与数据结构","数学"]
    }
    ,    {
        title:"云计算&大数据",
        content:["大数据","Hadoop","Spark","Hbase","Storm","云计算","AWS","Docker","Kubernetes"]
    }
]
const innerBox6=[
    {
        title:"运维&测试",
        content:["运维","自动化运维","运维工具","中间件","Linux","测试","功能测试","性能测试","自动化测试","接口测试","安全测试"]
    }
    ,    {
        title:"数据库",
        content:["MySQL","Redis","MongoDB","Oracle","SQL Server","NoSql"]
    }
]
const innerBox7=[
    {
        title:"UI设计&多媒体",
        content:["模型制作","动效动画","设计基础","设计工具","APPUI设计","产品交互"]
    }
    ,    {
        title:"游戏",
        content:["Unity 3D","Cocos2d0x"]
    }
]
const recomment_box_1=
[
        {
            id:"1",
            content:"混合开发入门 主流开发方案实战京东移动端APP",
            money:"￥266.00",
            grade:"初级",
            number:"216",
            red:false,
            moneys:true,
            first_star:true,
            last_star:true,
            star:false,
        },
        {
            id:"2",
            content:"混合开发入门 主流开发方案实战京东移动端APP",
            money:"￥266.00",
            grade:"初级",
            number:"216",
            moneys:false,
            red:false,
            first_star:false,
            last_star:true,
            star:false,
        },
        {
            id:"3",
            content:"混合开发入门 主流开发方案实战京东移动端APP",
            money:"￥266.00",
            grade:"初级",
            number:"216",
            moneys:true,
            red:true,
            first_star:true,
            last_star:true,
            star:true,
        },
        {
            id:"4",
            content:"混合开发入门 主流开发方案实战京东移动端APP",
            moneys:false,
            money:"￥266.00",
            grade:"初级",
            number:"216",
            red:false,
            first_star:false,
            last_star:true,
            star:false,
        }
]
const recomment_box_2=
[
        {
            id:"1",
            content:"混合开发入门 主流开发方案实战京东移动端APP",
            money:"￥266.00",
            grade:"初级",
            number:"216",
            red:false,
            moneys:true,
            first_star:true,
            last_star:true,
            star:false,
        },
        {
            id:"2",
            content:"混合开发入门 主流开发方案实战京东移动端APP",
            money:"￥266.00",
            grade:"初级",
            number:"216",
            moneys:false,
            red:false,
            first_star:false,
            last_star:true,
            star:false,
        },
        {
            id:"3",
            content:"混合开发入门 主流开发方案实战京东移动端APP",
            money:"￥266.00",
            grade:"初级",
            number:"216",
            moneys:true,
            red:true,
            first_star:true,
            last_star:true,
            star:true,
        },
        {
            id:"4",
            content:"混合开发入门 主流开发方案实战京东移动端APP",
            moneys:false,
            money:"￥266.00",
            grade:"初级",
            number:"216",
            red:false,
            first_star:false,
            last_star:true,
            star:false,
        }
]
const recomment_box_3=
[
        {
            id:"1",
            content:"混合开发入门 主流开发方案实战京东移动端APP",
            money:"￥266.00",
            grade:"初级",
            number:"216",
            red:false,
            moneys:true,
            first_star:true,
            last_star:true,
            star:false,
        },
        {
            id:"2",
            content:"混合开发入门 主流开发方案实战京东移动端APP",
            money:"￥266.00",
            grade:"初级",
            number:"216",
            moneys:false,
            red:false,
            first_star:false,
            last_star:true,
            star:false,
        },
        {
            id:"3",
            content:"混合开发入门 主流开发方案实战京东移动端APP",
            money:"￥266.00",
            grade:"初级",
            number:"216",
            moneys:true,
            red:true,
            first_star:true,
            last_star:true,
            star:true,
        },
        {
            id:"4",
            content:"混合开发入门 主流开发方案实战京东移动端APP",
            moneys:false,
            money:"￥266.00",
            grade:"初级",
            number:"216",
            red:false,
            first_star:false,
            last_star:true,
            star:false,
        }
]
const recomment_box_4=
[
        {
            id:"1",
            content:"混合开发入门 主流开发方案实战京东移动端APP",
            money:"￥266.00",
            grade:"初级",
            number:"216",
            red:false,
            moneys:true,
            first_star:true,
            last_star:true,
            star:false,
        },
        {
            id:"2",
            content:"混合开发入门 主流开发方案实战京东移动端APP",
            money:"￥266.00",
            grade:"初级",
            number:"216",
            moneys:false,
            red:false,
            first_star:false,
            last_star:true,
            star:false,
        },
        {
            id:"3",
            content:"混合开发入门 主流开发方案实战京东移动端APP",
            money:"￥266.00",
            grade:"初级",
            number:"216",
            moneys:true,
            red:true,
            first_star:true,
            last_star:true,
            star:true,
        },
        {
            id:"4",
            content:"混合开发入门 主流开发方案实战京东移动端APP",
            moneys:false,
            money:"￥266.00",
            grade:"初级",
            number:"216",
            red:false,
            first_star:false,
            last_star:true,
            star:false,
        }
]
const recomment_box_5=
[
        {
            id:"1",
            content:"混合开发入门 主流开发方案实战京东移动端APP",
            money:"￥266.00",
            grade:"初级",
            number:"216",
            red:false,
            moneys:true,
            first_star:true,
            last_star:true,
            star:false,
        },
        {
            id:"2",
            content:"混合开发入门 主流开发方案实战京东移动端APP",
            money:"￥266.00",
            grade:"初级",
            number:"216",
            moneys:false,
            red:false,
            first_star:false,
            last_star:true,
            star:false,
        },
        {
            id:"3",
            content:"混合开发入门 主流开发方案实战京东移动端APP",
            money:"￥266.00",
            grade:"初级",
            number:"216",
            moneys:true,
            red:true,
            first_star:true,
            last_star:true,
            star:true,
        },
        {
            id:"4",
            content:"混合开发入门 主流开发方案实战京东移动端APP",
            moneys:false,
            money:"￥266.00",
            grade:"初级",
            number:"216",
            red:false,
            first_star:false,
            last_star:true,
            star:false,
        }
]
const recomment_box_6=
[
        {
            id:"1",
            content:"混合开发入门 主流开发方案实战京东移动端APP",
            money:"￥266.00",
            grade:"初级",
            number:"216",
            red:false,
            moneys:true,
            first_star:true,
            last_star:true,
            star:false,
        },
        {
            id:"2",
            content:"混合开发入门 主流开发方案实战京东移动端APP",
            money:"￥266.00",
            grade:"初级",
            number:"216",
            moneys:false,
            red:false,
            first_star:false,
            last_star:true,
            star:false,
        },
]
const recomment_box_7=
[
        {
            id:"1",
            content:"混合开发入门 主流开发方案实战京东移动端APP",
            money:"￥266.00",
            grade:"初级",
            number:"216",
            red:false,
            moneys:true,
            first_star:true,
            last_star:true,
            star:false,
        },
        {
            id:"2",
            content:"混合开发入门 主流开发方案实战京东移动端APP",
            money:"￥266.00",
            grade:"初级",
            number:"216",
            moneys:false,
            red:false,
            first_star:false,
            last_star:true,
            star:false,
        },
        {
            id:"3",
            content:"混合开发入门 主流开发方案实战京东移动端APP",
            money:"￥266.00",
            grade:"初级",
            number:"216",
            moneys:true,
            red:true,
            first_star:true,
            last_star:true,
            star:true,
        },
        {
            id:"4",
            content:"混合开发入门 主流开发方案实战京东移动端APP",
            moneys:false,
            money:"￥266.00",
            grade:"初级",
            number:"216",
            red:false,
            first_star:false,
            last_star:true,
            star:false,
        }
]
//轮播图下
const pathBanner=[
    {
        title:"前沿技术",
        content:"Web前端攻城狮"
    },
    {
        title:"Java攻城狮",
        content:"综合就业排名第一"
    },
    {
        title:"Python攻城狮",
        content:"应用领域最为广泛的语言"
    },
    {
        title:"Android攻城狮",
        content:"移动设备市场份额第一"
    },
    {
        title:"PHP攻城狮",
        content:"Web开发首选语言"
    }
    ]
//----------------------------------卡片模块标题------------------------------------
const TypesTit1={
    one:"实"
    ,two:"战"
    ,three:"推"
    ,four:"荐"
}
const TypesTit2={
    one:"新"
    ,two:"上"
    ,three:"好"
    ,four:"课"
}
const TypesTit3={
    one:"新"
    ,two:"手"
    ,three:"入"
    ,four:"门"
}
const TypesTit4={
    one:"技"
    ,two:"能"
    ,three:"提"
    ,four:"升"
}
const TypesTit5={
    one:"前"
    ,two:"沿"
    ,three:"技"
    ,four:"术"
}
const TypesTit6={
    one:"精"
    ,two:"彩"
    ,three:"手"
    ,four:"记"
    ,five:"及"
    ,six:"猿"
    ,seven:"问"
}
const TypesTit7={
    one:"慕"
    ,two:"课"
    ,three:"精"
    ,four:"英"
    ,five:"名"
    ,six:"师"
}
const TypesTit8={
    one:"吊"
    ,two:"炸"
    ,three:"天"
    ,four:"全"
    ,five:"明"
    ,six:"星"
}
//卡片信息
const Card1=[
    {
        text1:"Linux"
        ,text2:"计算机网络"
        ,title:"编程必备基础 计算机组成原理+操作系统+计算机网络"
        ,info1:"实战"
        ,info2:"中级"
        ,person:"1781"
        ,star:true
        ,money:"￥236.00"
    }
    ,{
        text1:"Java"
        ,text2:"算法与数据结构"
        ,title:"剑指Java面试-Offer直通车"
        ,info1:"实战"
        ,info2:"中级"
        ,person:"4539"
        ,star:true
        ,money:"￥299.00"
    }
    ,{
        text1:"Vue.js"
        ,title:"Vue2.5开发去哪儿网App 从零基础入门到实战项目"
        ,info1:"实战"
        ,info2:"初级"
        ,person:"9949"
        ,star:true
        ,money:"￥366.00"
    }
    ,{
        text1:"算法"
        ,text2:"算法与数据结构"
        ,title:"玩转算法系列--图论精讲  面试升职必备（Java版）"
        ,info1:"实战"
        ,info2:"中级"
        ,person:"599"
        ,star:true
        ,money:"￥348.00"
    }
    ,{
        text1:"SpringBoot"
        ,text2:"SpringCloud"
        ,title:"Spring Cloud Alibaba微服务从入门到进阶"
        ,info1:"实战"
        ,info2:"高级"
        ,person:"548"
        ,star:true
        ,money:"￥399.00"
        ,upgrade:"升级"
    }
]
const Card2=[
    {
        text1:"Java"
        ,title:"一站式学习Java网络编程全面理解BIO/NIO/AIO"
        ,info1:"实战"
        ,info2:"初级"
        ,person:"155"
        ,star:true
        ,money:"￥255.00"
        ,delete:"￥299"
        ,new:"新课"
        ,offer:"限时优惠"
    }
    ,{
        text1:"SpringBoot"
        ,text2:"Spring Cloud"
        ,title:"Spring Cloud微服务安全实战"
        ,info1:"实战"
        ,info2:"中级"
        ,person:"120"
        ,star:true
        ,money:"￥255.00"
        ,delete:"￥299"
        ,new:"新课"
        ,offer:"限时优惠"
    }
    ,{
        text1:"Android"
        ,title:"企业级Android应用架构设计与开发"
        ,info1:"实战"
        ,info2:"中级"
        ,person:"177"
        ,star:true
        ,money:"￥249.00"
        ,delete:"￥299"
        ,new:"新课"
        ,offer:"限时优惠"
    }
    ,{
        text1:"Node.js"
        ,text2:"小程序"
        ,title:"微信小程序云开发-从0打造云音乐全栈小程序"
        ,info1:"实战"
        ,info2:"中级"
        ,person:"273"
        ,star:true
        ,money:"￥348.00"
        ,delete:"￥299"
    }
    ,{
        text1:"React.JS"
        ,text2:"Sass/Less"
        ,title:"Electron+React+七牛云 实战跨平台桌面应用"
        ,info1:"实战"
        ,info2:"中级"
        ,person:"159"
        ,star:true
        ,money:"￥199.00"
        ,delete:"￥248"
        ,new:"新课"
        ,offer:"限时优惠"
    }
    ,    {
        text1:"iOS"
        ,text2:"Vus.js"
        ,title:"混合开发入门 主流开发方案实战京东移动端APP"
        ,info1:"实战"
        ,info2:"初级"
        ,person:"227"
        ,upgrade:"升级"
        ,star:true
        ,money:"￥255.00"
    }
    ,{
        text1:"数学"
        ,title:"专为程序员设计的统计课 彻底学会统计分析"
        ,info1:"实战"
        ,info2:"初级"
        ,person:"242"
        ,star:true
        ,money:"￥266.00"
        ,delete:"￥299"
        ,upgrade:"升级"
        ,offer:"限时优惠"
    }
    ,{
        text1:"Android"
        ,title:"企业级Android应用架构设计与开发"
        ,info1:"实战"
        ,info2:"中级"
        ,person:"177"
        ,star:true
        ,money:"￥249.00"
        ,delete:"￥299"
        ,new:"热门"
        ,offer:"限时优惠"
    }
    ,{
        text1:"Node.js"
        ,text2:"小程序"
        ,title:"微信小程序云开发-从0打造云音乐全栈小程序"
        ,info1:"实战"
        ,info2:"中级"
        ,person:"273"
        ,star:true
        ,money:"￥348.00"
        ,delete:"￥299"
    }
    ,{
        text1:"React.JS"
        ,text2:"Sass/Less"
        ,title:"Electron+React+七牛云 实战跨平台桌面应用"
        ,info1:"实战"
        ,info2:"中级"
        ,person:"159"
        ,star:true
        ,money:"￥199.00"
        ,delete:"￥248"
        // ,new:"新课"
        ,upgrade:"升级"
        ,offer:"限时优惠"
    }
]
const Card3=[
    {
        text1:"Java"
        ,title:"一站式学习Java网络编程全面理解BIO/NIO/AIO"
        ,info1:"实战"
        ,info2:"初级"
        ,person:"155"
        ,star:true
        ,money:"￥255.00"
        ,delete:"￥299"
        ,new:"新课"
        ,offer:"限时优惠"
        ,title2:[{
            title:"站上微信小程序风口，实现职业华丽转身"
            ,content:"入门技能+项目开发，逐步深入学习微信小程序开发"
            },
            {
            title:"盘点最主流的前端框架有哪些？"
            ,content:"上万人的选择打消你对主流框架的疑惑"
            }
        ]
    }
    ,{
        text1:"SpringBoot"
        ,text2:"Spring Cloud"
        ,title:"Spring Cloud微服务安全实战"
        ,info1:"实战"
        ,info2:"中级"
        ,person:"120"
        ,star:true
        ,money:"￥255.00"
        ,delete:"￥299"
        ,new:"新课"
        ,offer:"限时优惠"
    }
    ,{
        text1:"Android"
        ,title:"企业级Android应用架构设计与开发"
        ,info1:"实战"
        ,info2:"中级"
        ,person:"177"
        ,star:true
        ,money:"￥249.00"
        ,delete:"￥299"
        ,new:"新课"
        ,offer:"限时优惠"
    }
    ,{
        text1:"Node.js"
        ,text2:"小程序"
        ,title:"微信小程序云开发-从0打造云音乐全栈小程序"
        ,info1:"实战"
        ,info2:"中级"
        ,person:"273"
        ,star:true
        ,money:"￥348.00"
        ,delete:"￥299"
    }
    ,{
        text1:"React.JS"
        ,text2:"Sass/Less"
        ,title:"Electron+React+七牛云 实战跨平台桌面应用"
        ,info1:"实战"
        ,info2:"中级"
        ,person:"159"
        ,star:true
        ,money:"￥199.00"
        ,delete:"￥248"
        ,new:"新课"
        ,offer:"限时优惠"
    }
    ,    {
        text1:"iOS"
        ,text2:"Vus.js"
        ,title:"混合开发入门 主流开发方案实战京东移动端APP"
        ,info1:"实战"
        ,info2:"初级"
        ,person:"227"
        ,star:true
        ,money:"￥255.00"
    }
    ,{
        text1:"数学"
        ,title:"专为程序员设计的统计课 彻底学会统计分析"
        ,info1:"实战"
        ,info2:"初级"
        ,person:"242"
        ,star:true
        ,money:"￥266.00"
        ,delete:"￥299"
        ,new:"新课"
        ,offer:"限时优惠"
    }
    ,{
        text1:"Android"
        ,title:"企业级Android应用架构设计与开发"
        ,info1:"实战"
        ,info2:"中级"
        ,person:"177"
        ,star:true
        ,money:"￥249.00"
        ,delete:"￥299"
        ,new:"新课"
        ,offer:"限时优惠"
    }
    ,{
        text1:"Node.js"
        ,text2:"小程序"
        ,title:"微信小程序云开发-从0打造云音乐全栈小程序"
        ,info1:"实战"
        ,info2:"中级"
        ,person:"273"
        ,star:true
        ,money:"￥348.00"
        ,delete:"￥299"
    }
    ,{
        text1:"React.JS"
        ,text2:"Sass/Less"
        ,title:"Electron+React+七牛云 实战跨平台桌面应用"
        ,info1:"实战"
        ,info2:"中级"
        ,person:"159"
        ,star:true
        ,money:"￥199.00"
        ,delete:"￥248"
        ,new:"新课"
        ,offer:"限时优惠"
    }
]
const Card4=[
    {
        text1:"Java"
        ,title:"一站式学习Java网络编程全面理解BIO/NIO/AIO"
        ,info1:"实战"
        ,info2:"初级"
        ,person:"155"
        ,star:true
        ,money:"￥255.00"
        ,delete:"￥299"
        ,new:"新课"
        ,offer:"限时优惠"
        ,title2:[{
            title:"站上微信小程序风口，实现职业华丽转身"
            ,content:"入门技能+项目开发，逐步深入学习微信小程序开发"
            },
            {
            title:"盘点最主流的前端框架有哪些？"
            ,content:"上万人的选择打消你对主流框架的疑惑"
            }
        ]
    }
    ,{
        text1:"SpringBoot"
        ,text2:"Spring Cloud"
        ,title:"Spring Cloud微服务安全实战"
        ,info1:"实战"
        ,info2:"中级"
        ,person:"120"
        ,star:true
        ,money:"￥255.00"
        ,delete:"￥299"
        ,new:"新课"
        ,offer:"限时优惠"
    }
    ,{
        text1:"Android"
        ,title:"企业级Android应用架构设计与开发"
        ,info1:"实战"
        ,info2:"中级"
        ,person:"177"
        ,star:true
        ,money:"￥249.00"
        ,delete:"￥299"
        ,new:"新课"
        ,offer:"限时优惠"
    }
    ,{
        text1:"Node.js"
        ,text2:"小程序"
        ,title:"微信小程序云开发-从0打造云音乐全栈小程序"
        ,info1:"实战"
        ,info2:"中级"
        ,person:"273"
        ,star:true
        ,money:"￥348.00"
        ,delete:"￥299"
    }
    ,{
        text1:"React.JS"
        ,text2:"Sass/Less"
        ,title:"Electron+React+七牛云 实战跨平台桌面应用"
        ,info1:"实战"
        ,info2:"中级"
        ,person:"159"
        ,star:true
        ,money:"￥199.00"
        ,delete:"￥248"
        ,new:"新课"
        ,offer:"限时优惠"
    }
    ,    {
        text1:"iOS"
        ,text2:"Vus.js"
        ,title:"混合开发入门 主流开发方案实战京东移动端APP"
        ,info1:"实战"
        ,info2:"初级"
        ,person:"227"
        ,star:true
        ,money:"￥255.00"
    }
    ,{
        text1:"数学"
        ,title:"专为程序员设计的统计课 彻底学会统计分析"
        ,info1:"实战"
        ,info2:"初级"
        ,person:"242"
        ,star:true
        ,money:"￥266.00"
        ,delete:"￥299"
        ,new:"新课"
        ,offer:"限时优惠"
    }
    ,{
        text1:"Android"
        ,title:"企业级Android应用架构设计与开发"
        ,info1:"实战"
        ,info2:"中级"
        ,person:"177"
        ,star:true
        ,money:"￥249.00"
        ,delete:"￥299"
        ,new:"新课"
        ,offer:"限时优惠"
    }
    ,{
        text1:"Node.js"
        ,text2:"小程序"
        ,title:"微信小程序云开发-从0打造云音乐全栈小程序"
        ,info1:"实战"
        ,info2:"中级"
        ,person:"273"
        ,star:true
        ,money:"￥348.00"
        ,delete:"￥299"
    }
    ,{
        text1:"React.JS"
        ,text2:"Sass/Less"
        ,title:"Electron+React+七牛云 实战跨平台桌面应用"
        ,info1:"实战"
        ,info2:"中级"
        ,person:"159"
        ,star:true
        ,money:"￥199.00"
        ,delete:"￥248"
        ,new:"新课"
        ,offer:"限时优惠"
    }
]
const waterFullHot=[{
    
    img:"hot1"
    ,tag:"热门话题"
    ,title:"#【内推第2波】#"
    ,titleBr:" 打工奋斗7万落京户VS自主创业牧马城市，如何抉择？"
    ,lk:"了解详情"
    ,comeBack:"往期回顾"
    ,moreComeBack:"更多往期话题"
    ,content:"毕业求职？跳槽加薪？纠结滋润加班还是苦练x年自主创业？速速提问互撩，你在撩的极有可能就是你的Boss！激不激动？惊不惊喜？Offer已在这里！你的简历在哪里？Scott老师邮箱：wolf18387@qq.comJeson老师邮箱：jeson@imoocc.com"
    ,inner:
    [
        {    Img:"/hot2"
            ,main:"#【获奖名单戳查看更多】#"
            ,mainBr:" 当我们谈论Java时，我们都谈些什么？"
        },
        {
            Img:"/hot3"
            ,main:"#【内推第1波】#"
            ,mainBr:" 直击BAT面试机会！行业大佬在线答疑"
        },
        {
            Img:"/hot4"
            ,main:"#【花式填坑】第23期#"
            ,mainBr:" 运维进化篇：成为Python DevOps工程师有哪些必备条件？",
        }
    ]
}]
const active=
[
    {
        tag:"手记文章"
        ,title:"【干货合辑】都2019年下半年了， 抓紧上车 ，今年新热技术都在这里！"
        ,content:"互联网发展迅速，不进步就等于在落后，2019年前半年都要过去了，热门新技术你掌握了吗？ 还不知道该学什么怎么学？ 别担心，小慕给大家整理了一篇各大方向的新技术学习干货，点赞收藏走起！ 前端方向 热门技术：TypeScript、Vue、微信小程序 干货文章： 《从今天开始，拿起 TypeScript 做一个轮子的制造者》 《TypeScript应该怎么学》 《TypeScript入门》 《TypeS..."
        ,browse:"浏览 13872"
        ,recommend:"推荐  100"
        ,readMore:"阅读全文"
        ,img:"/ganhuo"

    }
    ,{
        tag:"手记文章"
        ,title:"前端技能点学习路线分享，职场进阶的奥秘都在这里了"
        ,content:"前端怎样入门？ 这一波良心推荐的【前端学习路线】干货，不谈虚的，直接来谈每个阶段要学习的内容 想入门前端的小伙伴们，那就放马过来吧！     首先，给大家分享一张最新的以 企业岗位需求为导向前端技能点图，如下   根据前端工程师技能点图，我们分为四个阶段： 第一阶段：前端基础 （HTML / CSS / HTML5 / CSS3 / JavaScript ） 干货文章： 初识HTML+CSS 【学..."
        ,browse:"浏览 28994"
        ,readMore:"阅读全文"
        ,img:"/qianduan"
        ,recommend:"推荐 249"
    },
    {
        tag:"手记文章"
        ,title:"【面试技巧系列】找工作、涨薪、跳槽都得来一份"
        ,content:"面试是程序员求职过程中最重要的一步 别以为面试技巧很虚 很多技术不错的人 恰恰输在了面试技巧上 知识点怎么复习、问题如何回答 怎么在面试时避免采坑、惊艳面试官 怎么与HR谈论薪资待遇…… 往往这些问题决定你能否成功应聘。 敲黑板划重点： 以下面试技巧神器你值得拥有！ 大量干货文章袭来预警~ 一、通用篇 干货文章： 聪明人喜欢这样写简历 如何有效地备战面试 【程序员】在面..."
        ,browse:"浏览  29510"
        ,recommend:"推荐 40"
        ,img:"/mianshi"
        ,readMore:"阅读全文"
    }
    ,{
        tag:"手记文章"
        , title:"【涨薪秘籍】安卓工程师的进阶实战之路"
        ,content:"Android知识杂乱无章，不知道从哪入手？ 技术更新频繁，学不动了，从业者该何去何从？ 工作多年，年龄上升工资却迟迟不涨，危机感满满，该如何破解？ 是时候该开启你的安卓实战之路啦！涨薪的奥秘都在这里！ 今天小慕给大家带来安卓三个阶段的学习路线，从项目入手，逐步深入的带你理解并掌握Android的核心技术，帮助你成为具备高薪实力的Android开发者，顺利破解职场危机！ 不多说啦，上干货。 第一阶..."
        ,readMore:"阅读全文"
        ,img:"/android"
        ,browse:"浏览 10428"
        ,recommend:"推荐 40"
    }
    ,{
        tag:"手记文章"
        ,title:"【React学习路线】从零进阶前端核心工程师"
        ,content:"哈喽，良心推荐小慕又来跟大家分享啦，今天分享的是React~ 面向工资编程，前端核心框架、加薪神器React了解一下！ React毫无疑问是前端界主流的框架，而框架本身就是热点，可以说是前端工程师们能力提升、快速晋升高级开发工程师的必备技能。 还不知道如何入门？ 技术提升遇到瓶颈？ 别担心，下面小慕就跟大家详细聊一下React的学习路线，入门到进阶的秘籍都在这里啦！ 第一阶段：React快速入门 ..."
        ,browse:"浏览  16130"
        ,img:"/react"
        ,recommend:"推荐 99"
        ,readMore:"阅读全文"
    }    ,{
        tag:"手记文章"
        ,title:"【干货推荐】java学习进入瓶颈？大牛带你快速攻克！"
        ,content:"java新手不知如何入门？ 经验多却面临上升瓶颈期？ 想进阶高级工程师还差点火候？ 今天这波最实用的java实战之路 以战养兵 为你打通职业发展脉络 沿着Java大牛们的思路， 逐步成长为一名业务与思想同样优秀的Java开发者。 就业、晋升、管理均游刃有余！ 不多说了，上干货！ 阅读指南：本文专为Java开发行业人员设计，分为四个阶段，循序渐进的带你进行SSM框架、SpringBoot框架、微服务..."
        ,browse:"浏览  29905"
        ,img:"/niu"
        ,recommend:"推荐 164"
        ,readMore:"阅读全文"
    }
]
const activeGreen=
[
    {
        tag:"相关猿问"
        ,problem:"java好学吗.??pp"
        ,reply:"最赞回答"
        ,content:"挺好的!"
        ,more:"共274个回答"
    }
    ,    {
        tag:"相关猿问"
        ,problem:"【有奖问答】与大咖交流前端JS与框架开发，免费赢取前端图书（11.28-12.4）"
        ,reply:"最赞回答"
        ,content:"我觉得不管学习哪门语言，到后面总还是要学习一下规范，程序员的素养必不可少啊！！"
        ,more:"共158个回答"
    },    {
        tag:"相关猿问"
        ,problem:"各位猿或者媛，一般几点睡啊。有时忍住头痛看java到很晚，第二天就头痛一整天"
        ,reply:"已采纳回答"
        ,content:"没有什么事情是需要熬夜完成的"
        ,more:"共374个回答"
    }, {
        tag:"相关猿问"
        ,problem:"话说，大家想编程的最初初衷是什么"
        ,reply:"最赞回答"
        ,content:"说兴趣的话有没有人没打我...."
        ,more:"共501个回答"
    }, {
        tag:"相关猿问"
        ,problem:"reg=/^\\w{1,}@\\d{3}.[a-z]{3,6}$/;是什么意思呀？"
        ,more:"共501个回答"
    }
]
const teacherCard=
    [
        {
            name:"7七月"
            ,title:"全栈工程师"
            ,content:"十年研发及团队管理经验，对程序员面临的各种问题深有体会；精通Python、Java、Node.js、JavaScript等语言，对Web的基础研发、高并发处理与分布式有非常深入的理解。课程讲解深入浅出，极为擅长培养学生的编程思维。"
            ,img:"/qiyue"
        }
        ,{
            name:"廖师兄"
            ,title:"JAVA开发工程师"
            ,content:"载着干货的老司机。微服务，分布式架构方面经验丰富。"
            ,img:"/liao"
        }
        ,{
            name:"liuyubobobo"
            ,title:"全栈工程师"
            ,content:"创业者，全栈工程师，持续学习者。对技术开发，产品设计、前后端，ios，html5，智能算法等领域均有接触；拥有多款独立App作品；对一切可编程的东西有浓厚兴趣，对游戏编程格外感兴趣。相信编程改变一切。"
            ,img:"/liuyu"
        }
        ,{
            name:"慕课官方号"
            ,title:"页面重构设计"
            ,content:"慕课，Massive（大规模）Open（开放）Online（在线）Course（课程）。专注做好IT技能教育的MOOC，符合互联网发展潮流接地气儿的MOOC。我们有更多免费资源，我们只教有用的，我们专心做教育。"
            ,img:"/imooc"
        }
        ,{
            name:"Oeasy"
            ,title:"页面重构设计"
            ,content:"他，授课风趣幽默，激情四射，自称屌丝青年，中国传媒大学计算机教师；他，专注于网页制作、平面设计、多媒体等多个领域的软件以及应用的挖掘与创新，热爱分享，是新鲜热门软件和应用的导航标，他就是众粉丝心中的“Oeasy老湿”"
            ,img:"/oeasy"
        }
    ]
const teacherCard2= [
    {
        name:"JOJO"
        ,title:"全栈工程师"
        ,content:"具有15年开发和技术培训经验。致力于前后端技术和架构领域，有丰富的理论、实践经验。曾多次参与大型银行和互联网公司核心系统的架构设计和开发"
        ,img:"/jojo"
    },{
        name:"张轩"
        ,title:"Web前端工程师"
        ,content:"曾在Apple、百度担任高级前端开发工程师，是《React全栈:Redux Flux webpack Babel整合开发》该书作者，拥有丰富的Web开发经验，喜欢追寻新技术,同时致力于前端工程化，并且有大型SPA项目的架构及开发经验。"
        ,img:"/zhangxuan"
    },{
        name:"Stannum"
        ,title:"软件工程师"
        ,content:"目前在财经界俗称的“大摩”，一家成立于美国纽约的国际金融服务公司-摩根士丹利担任软件工程师和敏捷开发专家。 主攻Event Sourcing架构模式的应用。是一个“只有男同事,没有女同事”的程序媛一枚,先后就职于多家投资银行，负责开发“每一个bug都很贵”的内部交易系统,主导了股票交易执行系统和衍生品交易风险控制系统。"
        ,img:"/stannum"
    },{
        name:"咚咚呛"
        ,title:"全栈工程师"
        ,content:"目前就职于BAT的大数据部门，超过4年的技术研发经验，熟悉java、python研发，担任过多个系统研发主程，目前专注于分布式系统研发，在高并发、分布式系统有丰富的经验。"
        ,img:"/dongdongqiang"
    },{
        name:"CrazyCodeBoy"
        ,content:"深耕移动端领域8年有余，全栈技术专家，CSDN 博客专家，擅长Android、iOS、Flutter、React Native以及小程序项目开发，负责过前端、Java、Android、iOS等多平台项目的研发，有多款React Native App上线及管理经验。他享受编程、热爱开源、酷爱分享，平时除了写写博客外，也分享一些开源技术干货 · Github"
        ,img:"/wu"
    }
]
const star=
[
    {
        img:"/cat"
        ,name:"好帮手慕仰"
        ,title:"风骚课程学霸"
        ,position:"0"
    }
    ,{
        img:"/nv"
        ,name:"橋本奈奈未"
        ,position:"1"
        ,title:"神秘解疑大神"
    },{
        img:"/black"
        ,name:"量子位"
        ,title:"智慧文章王者"
        ,position:"2"
    },{
        img:"/yellow"
        ,name:"慕桂英1309418"
        ,title:"慕课第一土豪"
        ,position:"3"
    }
]
const otherList=[
    {
        class:"purple"
        ,img:"/1"
        ,title:"=风骚课程学霸="
        ,name:"好帮手慕灰灰"
        ,desc:"一周获得60积分"
    }
    ,    {
        class:"purple"
        ,img:"/2"
        ,title:"=风骚课程学霸="
        ,name:"好帮手慕星"
        ,desc:"一周获得66积分"
    }
    ,{
        class:"purple"
        ,img:"/3"
        ,title:"=风骚课程学霸="
        ,name:"好帮手慕魚姬"
        ,desc:"一周获得69积分"
    }
    ,{
        class:"purple"
        ,img:"/4"
        ,title:"=风骚课程学霸="
        ,name:"好帮手慕酷酷"
        ,desc:"一周获得66积分"
    }    ,{
        class:"purple"
        ,img:"/5"
        ,title:"=风骚课程学霸="
        ,name:"好帮手慕酷酷"
        ,desc:"一周获得66积分"
    }
    ,{
        class:"blue"
        ,img:"/6"
        ,title:"==智慧文章王者=="
        ,name:"macrozheng"
        ,desc:"一周发布手记 6 篇"
    }
    ,{
        class:"blue"
        ,img:"/7"
        ,title:"==智慧文章王者=="
        ,name:"码农土哥"
        ,desc:"一周发布手记 6 篇"
    }
    ,{
        class:"green"
        ,img:"/8"
        ,title:"=神秘解疑大神="
        ,name:"谢成"
        ,desc:"一周解题1个"
    }
    ,{
        class:"blue"
        ,img:"/9"
        ,title:"=神秘解疑大神="
        ,name:"Python学长"
        ,desc:"一周发布手记9篇"
    }
    ,{
        class:"purple"
        ,img:"/10"
        ,title:"=神秘解疑大神="
        ,name:"谢成"
        ,desc:"一周解题1个"
    }
    ,{
        class:"blue"
        ,img:"/11"
        ,title:"==智慧文章王者=="
        ,name:"macrozheng"
        ,desc:"一周发布手记 6 篇"
    }
    ,{
        class:"blue"
        ,img:"/12"
        ,title:"==智慧文章王者=="
        ,name:"码农土哥"
        ,desc:"一周发布手记 6 篇"
    }
    ,{
        class:"green"
        ,img:"/13"
        ,title:"qq_琥珀的眼泪_0"
        ,name:"谢成"
        ,desc:"一周解题1个"
    }
    ,{
        class:"green"
        ,img:"/13"
        ,title:"qq_琥珀的眼泪_0"
        ,name:"谢成"
        ,desc:"pardon110"
    }
    ,{
        class:"blue"
        ,img:"/14"
        ,title:"==智慧文章王者=="
        ,name:"macrozheng"
        ,desc:"一周发布手记 6 篇"
    }
    ,{
        class:"blue"
        ,img:"/15"
        ,title:"==智慧文章王者=="
        ,name:"macrozheng"
        ,desc:"一周发布手记 6 篇"
    }
    ,{
        class:"purple"
        ,img:"/16"
        ,title:"=风骚课程学霸="
        ,name:"好帮手慕酷酷"
        ,desc:"一周获得66积分"
    }
]
const footerLInk=[
    "企业合作"
    ,"人才招聘"
    ,"联系我们"
    ,"讲师招募"
    ,"帮助中心"
    ,"意见反馈"
    ,"慕课大学"
    ,"代码托管"
    ,"友情链接"
]
const footerimg=[
    {
        content:'官方公众号'
        ,img:'/微信'
        ,position:"/foot"
    }
    ,{
        content:'官方微博'
        ,img:'/微博'
    }
]
const fixed=[
    {comeback:"意见反馈"
    ,other:"邀请有奖"
    ,help:"帮助中心"
    ,aPP:"APP下载"
    ,Wechat:"官方微信"
    ,Top:"返回顶部"
}
]
export {
    list,
    sidebar
    ,innerBox
    ,innerBox2
    ,innerBox3
    ,innerBox4
    ,innerBox5
    ,innerBox6
    ,innerBox7
    ,recomment_box_1
    ,recomment_box_2
    ,recomment_box_3
    ,recomment_box_4
    ,recomment_box_5
    ,recomment_box_6
    ,recomment_box_7
    ,pathBanner
    ,TypesTit1
    ,TypesTit2
    ,TypesTit3
    ,TypesTit4
    ,TypesTit5
    ,TypesTit6
    ,TypesTit7
    ,TypesTit8
    ,Card1
    ,Card2
    ,Card3
    ,Card4
    ,waterFullHot
    ,active
    ,activeGreen
    ,teacherCard
    ,teacherCard2
    ,star
    ,otherList
    ,footerLInk
    ,footerimg
    ,fixed
} ; 
